import { kebabCase } from 'lodash'
import React, { 
  useState, 
  useEffect,
  useRef
} from 'react'
import parse from 'parser/parse-html'
import { 
  useParams,
  Outlet
} from 'react-router-dom'
import { useContent } from 'data/hooks'
import replace from 'parser/replace'

import { LoadingIndicator } from 'basecomps'

export const Content = props => {

  const params = useParams()
  const url = props.url || params.url
  const { title, content, blocks } = useContent(url)
  const [ parsedcontent, setParsedcontent ] = useState()
  const contentRef = useRef()
  const classtitle = kebabCase(title)
  const [current, setCurrent] = useState(false)

  const showhelpcontent = url => {

    if(props.showhelpcontent) {

      props.showhelpcontent(url)

    } else {      

      document.dispatchEvent(
        new CustomEvent(
          'playmotiv_showhelpcontent',
          {
            detail: {
              url: url
            }
          }
        )
      )
    }
  }

  useEffect(() => {

    setTimeout(() => {

      setParsedcontent(
        parse(content)
      )

      props.blocks && props.blocks(blocks)
      
    }, 100)

  }, [content, params])

  useEffect(() => { 
    
    setParsedcontent(null)

  }, [url])

  useEffect(() => {  

    if(contentRef.current && !current) {  

      let startvermaswaittime = new Date().getTime()
      const waitVermas = setInterval(() => {

        if(!contentRef.current) {

          clearInterval(waitPageMenu)
          return
        }

        const vermasgroups = contentRef.current.getElementsByClassName('wp-block-group vermas')
        if(vermasgroups.length) {

          clearInterval(waitVermas) 

          for (let vermasgroup of vermasgroups) {

            const groupSwitch = document.createElement('div')            
            groupSwitch.className = 'toggle'
            groupSwitch.addEventListener(
              'click', 
              () => {

                if(vermasgroup.getAttribute('data-open') == 'true') {                  

                  vermasgroup.removeAttribute('data-open')

                } else {                 

                  vermasgroup.setAttribute('data-open', 'true')
                }
              } 
            )
            vermasgroup.append(groupSwitch)
          }

        } else {

          const newwaittime = new Date().getTime()
          const diff = newwaittime - startvermaswaittime

          if(diff > 3000) {

            clearInterval(waitVermas)

            // console.log('Slides not found in 1.5 sec') // Check if need up wait time
          }
        }

      }, 300)

      let startslideswaittime = new Date().getTime()
      const waitHelpSlides = setInterval(() => {

        if(!contentRef.current) {

          clearInterval(waitPageMenu)
          return
        }

        const helpslides = contentRef.current.getElementsByClassName('wp-block-playmotivcloud-slide help')
        if(helpslides.length) {

          clearInterval(waitHelpSlides) 

          for (let helpslide of helpslides) {

            const contenturl = helpslide.id
            const slidetitle = helpslide.getElementsByClassName('Title')[0]
            const slidetitlehelp = document.createElement('div')            
            slidetitlehelp.className = 'help'
            slidetitlehelp.textContent = 'help'
            slidetitlehelp.addEventListener('click', () => showhelpcontent(contenturl) )
            slidetitle.append(slidetitlehelp)
          }

        } else {

          const newwaittime = new Date().getTime()
          const diff = newwaittime - startslideswaittime

          if(diff > 3000) {

            clearInterval(waitHelpSlides)

            // console.log('Slides not found in 1.5 sec') // Check if need up wait time
          }
        }

      }, 300)

      let startpagemenuswaittime = new Date().getTime()
      let pagemenu = null
      const waitPageMenu = setInterval(() => {

        if(!contentRef.current) {

          clearInterval(waitPageMenu)
          return
        }

        const pagemenus = contentRef.current.getElementsByClassName('pagemenu')
        if(pagemenus.length) {

          clearInterval(waitPageMenu)

          pagemenu = pagemenus.item(0)

          const options = pagemenu.getElementsByTagName('a')

          for (let option of options) {

            option.addEventListener(
              'click',
              e => {

                e.preventDefault()

                const sectionid = option.getAttribute('href').replace('#', '')
                const sectionelement = document.getElementById(sectionid)
                const secciontop = sectionelement.offsetTop
                const scrolltop = props.stickymenu ? 
                  secciontop - pagemenu.offsetHeight
                  : 
                  secciontop

                contentRef.current.scrollTop = scrolltop
              }
            )
          }

          const pagemenulinks = document.querySelectorAll('[rel="nofollow"]');
          if(pagemenulinks.length) {

            for (let pagemenulink of pagemenulinks) {

              pagemenulink.addEventListener(
                'click',
                e => {

                  e.preventDefault()

                  const sectionid = pagemenulink.getAttribute('href').replace('#', '')
                  const sectionelement = document.getElementById(sectionid)
                  const secciontop = sectionelement.offsetTop
                  const scrolltop = props.stickymenu ? 
                    secciontop - pagemenu.offsetHeight
                    : 
                    secciontop

                  contentRef.current.scrollTop = scrolltop
                }
              )
            }
          }

        } else {

          const newwaittime = new Date().getTime()
          const diff = newwaittime - startpagemenuswaittime

          if(diff > 3000) {

            clearInterval(waitPageMenu)

            // console.log('Page Menus not found in 1.5 sec') // Check if need up wait time

            const pagelinks = document.querySelectorAll('[rel="nofollow"]');
            if(pagelinks.length) {

              for (let pagelink of pagelinks) {

                pagelink.addEventListener(
                  'click',
                  e => {

                    e.preventDefault()

                    const sectionid = pagelink.getAttribute('href').replace('#', '')
                    const sectionelement = document.getElementById(sectionid)
                    const scrolltop = sectionelement.offsetTop

                    contentRef.current.scrollTop = scrolltop
                  }
                )
              }
            }          
          }
        }

      }, 300)   

      setCurrent(true) // Hack for simple render
    }

  }, [contentRef.current, url])  

  return <>
    <div
      ref={ contentRef } 
      className={`
        content
        ${ classtitle }
      `}
    >
      { 
        parsedcontent ?
        parsedcontent
        : 
        <LoadingIndicator text="Cargando ..." />
      }
    </div>
    <Outlet />
  </>
}
